
const mockPortfolioMenu = [
  {
    "label": "글로벌 투자대가",
    "link": "/mock/guru",
    "icon": "ri-shopping-bag-3-line"
  },
  {
    "label": "미국 연기금",
    "link": "/mock/fund",
    "icon": "ri-calendar-todo-line"
  },
  {
    "label": "투자 아이디어",
    "link": "/mock/algo",
    "icon": "ri-shopping-bag-3-line"
  }
];


const mockCurationMenu = [
  {
    "label": "바겐세일 종목",
    "icon": "ri-account-circle-line",
    "submenu": [
      {
        "label": "투자대가",
        "link": "/mock/curation/guruSale"
      },
      {
        "label": "미국연기금",
        "link": "/mock/curation/fundSale"
      }
    ]
  },  
  {
    "label": "투자 트랜드",
    "icon": "ri-account-circle-line",
    "submenu": [
      {
        "label": "투자대가트랜드",
        "link": "/mock/curation/guruTrend"
      },
      {
        "label": "미국연기금트랜드",
        "link": "/mock/curation/fundTrend"
      }
    ]
  },    
  /* {
    "label": "실적 분석",
    "link": "/earning",
    "icon": "ri-shopping-bag-3-line"
  }, */
  {
    "label": "간밤의 주요 이슈",
    "link": "/mock/news",
    "icon": "ri-pie-chart-2-line"
  },
  {
    "label": "알쏭달쏭 내부자 거래",
    "link": "/mock/insider",
    "icon": "ri-calendar-todo-line"
  }
];

const portfolioMenu = [
  {
    "label": "글로벌 투자대가",
    "link": "/guru",
    "icon": "ri-shopping-bag-3-line"
  },
  {
    "label": "미국 연기금",
    "link": "/fund",
    "icon": "ri-calendar-todo-line"
  },
  {
    "label": "투자 아이디어",
    "link": "/algo",
    "icon": "ri-shopping-bag-3-line"
  }
];


const curationMenu = [
  {
    "label": "바겐세일 종목",
    "icon": "ri-account-circle-line",
    "submenu": [
      {
        "label": "투자대가",
        "link": "/curation/guruSale"
      },
      {
        "label": "미국연기금",
        "link": "/curation/fundSale"
      }
    ]
  },  
  {
    "label": "모멘텀 종목",
    "icon": "ri-account-circle-line",
    "submenu": [
      {
        "label": "투자대가 ",
        "link": "/curation/guruMomentum"
      },
      {
        "label": "미국연기금",
        "link": "/curation/fundMomentum"
      }
    ]
  },    
  {
    "label": "투자 트랜드",
    "icon": "ri-account-circle-line",
    "submenu": [
      {
        "label": "투자대가트랜드",
        "link": "/curation/guruTrend"
      },
      {
        "label": "미국연기금트랜드",
        "link": "/curation/fundTrend"
      }
    ]
  },
  /* {
    "label": "실적 분석",
    "link": "/earning",
    "icon": "ri-shopping-bag-3-line"
  }, */
  {
    "label": "간밤의 주요 이슈",
    "link": "/news",
    "icon": "ri-pie-chart-2-line"
  },
  {
    "label": "알쏭달쏭 내부자 거래",
    "link": "/insider",
    "icon": "ri-calendar-todo-line"
  }
];


const introMenu = [
  /* {
    "label": "유료 서비스",
    "link": "/intro/pricing",
    "icon": "ri-pie-chart-2-line"
  }, */
  {
    "label": "API 서비스",
    "link": "/docs/api/",
    "icon": "ri-calendar-todo-line"
  },
  {
    "label": "About Us",
    "link": "/intro/aboutus",
    "icon": "ri-shopping-bag-3-line"
  }
  /* {
    "label": "블로그",
    "link": "/intro/blog",
    "icon": "ri-article-line"
  } */
];

export { portfolioMenu, curationMenu, introMenu, mockCurationMenu, mockPortfolioMenu };
